export default "__VITE_ASSET__cf0ce399__"